const BV_PRODUCT = 'RatingsAndReviews';

/**
 * Communicates data specific to the product page.
 * @param {ReviewStatistics} stats
 * @param {string} productId
 * @param {window} [$window=window] - window object for unit tests
 */
export const trackPageView = (stats, productId, $window = globalThis.window) => { // eslint-disable-line no-undef
  const numReviews = stats.totalReviewCount;
  const avgRating = stats.averageOverallRating;
  const percentRecommended = stats.recommendedCount / numReviews;
  const pageData = {
    bvProduct: BV_PRODUCT,
    productId,
    type: 'product',
    numReviews,
    avgRating,
    percentRecommended,
  };
  $window.BV.pixel.trackPageView(pageData); // eslint-disable-line no-undef
};

/**
 * Communicates data specific to the product page.
 * @param {Review[]} reviews
 * @param {window} [$window=window] - window object for unit tests
 */
export const trackImpression = (reviews, $window = globalThis.window) => { // eslint-disable-line no-undef
  reviews.forEach((review) => {
    const impressionData = {
      bvProduct: BV_PRODUCT,
      productId: review.productId,
      contentId: review.reviewId,
      contentType: 'review',
    };
    $window.BV.pixel.trackImpression(impressionData); // eslint-disable-line no-undef
  });
};

/**
 * Tracks an event with the provided review and container ID.
 * Merged both [trackInView] and [trackViewedCGC] since they
 *  take the same params and should execute at same time.
 * @param {Review} review
 * @param {string} containerId
 * @param {window} [$window=window] - window object for unit tests
 */
export const trackInViewAndViewedUCG = (review, containerId, $window = globalThis.window) => { // eslint-disable-line no-undef
  const inViewData = {
    bvProduct: BV_PRODUCT,
    productId: review.productId,
  };
  $window.BV.pixel.trackInView(inViewData, { containerId }); // eslint-disable-line no-undef
  $window.BV.pixel.trackViewedCGC(inViewData, { containerId }); // eslint-disable-line no-undef
};

/**
 * Tracks an event with the provided name, product ID and 2 optional detail fields.
 * @param {string} name
 * @param {string} productId
 * @param {undefined | string} detail1
 * @param {undefined | string} detail2
 * @param {window} [$window=window] - window object for unit tests
 */
export const trackEvent = (name, productId, detail1 = '', detail2 = '', $window = globalThis.window) => { // eslint-disable-line no-undef
  $window.BV.pixel.trackEvent('Feature', { // eslint-disable-line no-undef
    type: 'Used',
    name,
    productId,
    bvProduct: BV_PRODUCT,
    detail1,
    detail2,
  });
};
